import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

export interface DiscardRequestV2SubmissionModalProps {
  onRequestClose: () => void;
  onRequestSubmit: () => void;
}

export default function DiscardRequestV2SubmissionModal(
  props: DiscardRequestV2SubmissionModalProps
): JSX.Element {
  return (
    <Modal
      title="Discard request?"
      onRequestSubmit={props.onRequestSubmit}
      onRequestClose={props.onRequestClose}
      buttons={[
        {
          text: 'Cancel',
          style: ButtonStyle.TERTIARY_GRAY,
          onClick: props.onRequestClose,
        },
        {
          text: 'Discard',
          submit: true,
          style: ButtonStyle.PRIMARY,
        },
      ]}
    >
      <div>
        If you discard this request, it can’t be submitted or modified.
        <p />
        <p />
        Any tasks that were submitted will be marked as “Cancelled” or “Invalid,” which are terminal statuses
        and can’t be changed.
      </div>
    </Modal>
  );
}
